<template>
  <article class="col-span-full pt-10 lg:py-0">
    <NuxtLink
      :to="card.link"
      :rel="isExternalLink(card.link) ? 'external' : undefined"
      class="group grid grid-cols-12 gap-3 lg:gap-9"
    >
      <figure
        :class="{
          'lg:order-last': imagePosition === 'left',
          'lg:order-first': imagePosition === 'right',
        }"
        class="col-span-full aspect-[756/510] overflow-clip rounded-lg lg:col-span-7 lg:max-w-none"
      >
        <NuxtImg
          :src="card.image.filename"
          :alt="card.image.alt"
          sizes="400px md:968px lg:720px"
          loading="lazy"
          class="ease-out-expo size-full object-cover transition-transform duration-700 group-hover:scale-[1.025]"
        />
      </figure>

      <div
        class="col-span-full flex flex-col justify-center gap-5 py-4 md:px-5 lg:col-span-5"
      >
        <h3 class="text-md font-bold lg:text-2xl">
          {{ card.title }}
        </h3>
        <p
          v-if="card.description"
          class="text-secondary text-sm leading-normal"
        >
          {{ card.description }}
        </p>

        <UiButton
          :label="ctaLabel"
          theme="dark"
          variant="outline"
          size="sm"
          right-icon="arrow-right"
        />
      </div>
    </NuxtLink>
  </article>
</template>

<script setup lang="ts">
import type { CardListCard } from '@/components/card/CardList.vue'
import { isExternalLink } from '@/utils/link-utils'

defineProps<{
  card: CardListCard
  imagePosition?: 'left' | 'right'
  ctaLabel: string
}>()
</script>
